<main class="bg-black text-white min-h-screen overflow-x-hidden">
  <section class="relative min-h-[65vh] flex items-center pt-24 pb-14 overflow-hidden page-hero-gradient">
    <div class="absolute -top-48 right-0 w-[700px] h-[700px] bg-varroc-accent/5 rounded-full blur-3xl"></div>
    <div class="relative z-10 max-w-7xl mx-auto px-6 w-full">
      <div class="max-w-3xl">
        <a routerLink="/solutions/business" class="back-nav" data-aos="fade-down">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient"><polyline points="15 18 9 12 15 6"></polyline></svg>
          Back
        </a>
        <h1 class="hero-col font-black mb-5" data-aos="fade-up" data-aos-delay="100">Automotive <span class="text-varroc-accent">OEM</span> Solutions</h1>
        <p class="text-varroc-text-gray text-lg leading-relaxed mb-8 max-w-2xl" data-aos="fade-up" data-aos-delay="200">
          Full-stack connected vehicle intelligence for OEMs — from real-time telematics and OTA updates to in-vehicle app ecosystems and driver insight platforms.
        </p>
        <div class="flex flex-wrap gap-4" data-aos="fade-up" data-aos-delay="300">
          <a routerLink="/contact-us" class="bg-varroc-accent text-white font-bold px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all">Request a Demo</a>
          <!-- <a routerLink="/resources" class="border border-varroc-accent/40 font-semibold px-8 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all">Case Studies</a> -->
        </div>
      </div>
    </div>
  </section>
  <nav class="sticky-product-nav">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex overflow-x-auto">
        <a *ngFor="let s of sections" (click)="scrollTo(s.id)" [class.active]="activeSection === s.id" class="cursor-pointer flex-shrink-0">
          <i class='bx text-base' [class]="s.icon"></i> {{ s.label }}
        </a>
      </div>
    </div>
  </nav>
  <div class="max-w-7xl mx-auto px-6 py-16 space-y-20">
    <section id="overview" class="section-anchor">
      <div class="mb-8" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Overview</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Purpose-Built for Automotive OEMs</h2>
        <p class="text-varroc-text-gray text-lg max-w-3xl">ConnectIQ delivers a complete connected vehicle stack that integrates with existing OEM infrastructure — from vehicle ECUs to dealer management systems.</p>
      </div>
      <div class="grid md:grid-cols-3 gap-6 border-t border-varroc-border pt-6">
        <div *ngFor="let m of metrics" class="border-l border-varroc-border pl-5 first:border-l-0 first:pl-0">
          <div class="text-varroc-accent font-black text-3xl mb-2">{{ m.val }}</div>
          <div class="text-varroc-text-gray text-sm">{{ m.label }}</div>
        </div>
      </div>
    </section>
    <div class="accent-divider"></div>
    <section id="features" class="section-anchor">
      <div class="mb-8" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Capabilities</span>
        <h2 class="text-4xl font-black mt-2 mb-4">What We Deliver for OEMs</h2>
        <p class="text-varroc-text-gray text-lg max-w-3xl">Connected services, data intelligence, security, and monetization layers designed to fit the OEM stack without unnecessary card-heavy UI.</p>
      </div>
      <div class="grid md:grid-cols-2 gap-x-10 gap-y-8">
        <div *ngFor="let f of features; let i = index" class="border-b border-varroc-border pb-6" [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 80).toString()">
          <div class="flex items-start gap-4">
            <div class="w-11 h-11 bg-varroc-accent/15 rounded-xl flex items-center justify-center flex-shrink-0">
              <img *ngIf="f.iconImage; else defaultFeatureIcon" [src]="f.iconImage" [alt]="f.title + ' icon'" class="w-6 h-6 object-contain" />
              <ng-template #defaultFeatureIcon>
                <i class='bx icon-gradient text-xl' [class]="f.icon"></i>
              </ng-template>
            </div>
            <div>
              <h3 class="text-white font-bold mb-2">{{ f.title }}</h3>
              <p class="text-varroc-text-gray text-sm leading-relaxed">{{ f.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="accent-divider"></div>
    <section id="outcomes" class="section-anchor">
      <div class="mb-8" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Outcomes</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Proven OEM Results</h2>
        <p class="text-varroc-text-gray text-lg max-w-3xl">From faster launches to stronger digital ownership experiences, the platform is designed to help OEM teams scale connected programs with cleaner execution.</p>
      </div>
      <div class="border-t border-varroc-border pt-6" data-aos="fade-up">
        <p class="text-varroc-text-gray text-lg mb-6">Ready to transform your connected vehicle strategy?</p>
        <a routerLink="/contact-us" class="inline-block bg-varroc-accent text-white font-bold px-10 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all">Talk to Our Team</a>
      </div>
    </section>
  </div>
</main>
